import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function StickyCta() {
  const loc = useLocation();
  // Hide on contact page (form already visible) & legal pages
  const hidden = /^\/(kontakt|obchodni-podminky|ochrana-osobnich-udaju|cookies|provozovatele)/.test(loc.pathname);
  if (hidden) return null;
  return (
    <div
      className="lg:hidden fixed bottom-4 inset-x-4 z-30"
      data-testid="sticky-mobile-cta"
    >
      <Link
        to="/kontakt#poptavka"
        className="block text-center bg-burgundy hover:bg-burgundy-hover text-ivory py-3.5 rounded-sm shadow-lg shadow-burgundy/20 tracking-wide"
      >
        Poptat termín
      </Link>
    </div>
  );
}
